import React, { useState, useCallback, useEffect } from 'react';
import { orgTypes } from '../../Constants';
import useApi from '../../api/useApi';

function CreateOrganization({ handleClose, notification, action, selectedProject, refreshList }) {
  const orgId = JSON.parse(localStorage.user).organization.id;
  const { userId } = JSON.parse(localStorage.user).user;
  const formModel = {
    projectName: '',
    shortName: '',
    organizationId: orgId,
    createdBy: userId,
    status: action === 'create' ? 'Active' : '',
    sourceAddress: {
      location: '',
      city: '',
      state: '',
      country: '',
      zip: '',
    },
    destinationAddress: {
      location: '',
      city: '',
      state: '',
      country: '',
      zip: '',
    },
  };

  const [formData, setFormData] = useState(formModel);
  const [{ isLoading, isError, data }, postData] = useApi();
  const [state, getDataForUpdate] = useApi();
  const [state2, updateData] = useApi();

  // useEffect(() => {
  //   const _formData = document.getElementById('form-data');
  //   _formData.setAttribute('autocomplete', 'off');
  // }, []);

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const handleSourceAddressChange = useCallback((e) =>
    setFormData({ ...formData, sourceAddress: { ...formData.sourceAddress, [e.target.name]: e.target.value } })
  );
  const handleDestinationAddressChange = useCallback((e) =>
    setFormData({
      ...formData,
      destinationAddress: { ...formData.destinationAddress, [e.target.name]: e.target.value },
    })
  );
  useEffect(() => {
    if (action === 'update') {
      getDataForUpdate(`/project/${selectedProject}`, 'GET');
    }
  }, [action]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (action === 'create') postData(`/project`, 'POST', formData);
    else updateData(`/project/${selectedProject}`, 'PATCH', formData);
  };

  // create response
  useEffect(() => {
    if (!isLoading && !isError && data) {
      setFormData({ ...formModel });
      notification('success', 'Project created successfully');
      handleClose();
      refreshList();
    }

    if (isError) {
      notification('error', `Unable to create project`);
      handleClose();
    }
  }, [isLoading, isError, data]);

  // getOrganization for update response
  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setFormData({
        ...state.data.project,
        sourceAddress: {
          ...state.data.project.sourceAddress,
          location: state.data.project.sourceAddress ? state.data.project.sourceAddress.locality : '',
        },
        destinationAddress: {
          ...state.data.project.destinationAddress,
          location: state.data.project.destinationAddress ? state.data.project.destinationAddress.locality : '',
        },
      });
    }
  }, [state]);

  // update response
  useEffect(() => {
    if (!state2.isLoading && !state2.isError && state2.data != null) {
      notification('success', `Project Updated Successfully.`);
      handleClose();
      refreshList();
    }
    if (state2.isError) {
      notification('error', `Unable to Update Project.`);
      handleClose();
    }
  }, [state2]);
  
  return (
    <div
      className="flex justify-center items-center h-full w-full fixed z-20 px-16 pt-16"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))', overflowY: 'scroll' }}
    >
      <div className="bg-white w-3/4 py-6 pl-16 pr-2 relative rounded-3xl">
        <img
          src="assets/img/Close.svg"
          className="absolute top-6 right-10 h-4 cursor-pointer"
          alt=""
          onClick={handleClose}
        />

        <p className="font-bold text-lg text-textBlue1">{action === 'create' ? 'CREATE' : 'EDIT'} PROJECT</p>

        <form className="mt-6 flex flex-wrap" autoComplete="new-password" onSubmit={handleSubmit}>
          <div className="flex w-1/2 items-center  my-3">
            <label htmlFor="projectName" className="block text-parameter w-1/3 text-sm">
              PROJECT
            </label>
            <input
              type="text"
              value={formData.projectName}
              name="projectName"
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleInputChange}
            />
          </div>

          <div className="flex w-1/2 items-center">
            <label htmlFor="shortName" className="block text-parameter w-1/3 text-sm">
              SHORT NAME
            </label>
            <input
              type="text"
              value={formData.shortName}
              name="shortName"
              autoComplete="off"
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleInputChange}
            />
          </div>
          <p className="font-black text-base w-full text-primary">SOURCE ADDRESS</p>
          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="address" className="block text-parameter w-1/3 text-sm">
              ADDRESS
            </label>
            <input
              type="text"
              value={formData.sourceAddress?.location}
              autoComplete="new-password"
              name="location"
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleSourceAddressChange}
            />
          </div>
          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="city" className="block text-parameter w-1/3 text-sm">
              CITY
            </label>
            <input
              type="text"
              value={formData.sourceAddress?.city}
              autoComplete="new-password"
              name="city"
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleSourceAddressChange}
            />
          </div>
          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="state" className="block text-parameter w-1/3 text-sm">
              STATE
            </label>
            <input
              type="text"
              name="state"
              autoComplete="new-password"
              value={formData.sourceAddress?.state}
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleSourceAddressChange}
            />
          </div>
          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="country" className="block text-parameter w-1/3 text-sm">
              COUNTRY
            </label>
            <input
              type="text"
              name="country"
              autoComplete="new-password"
              value={formData.sourceAddress?.country}
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleSourceAddressChange}
            />
          </div>
          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="zip" className="block text-parameter w-1/3 text-sm">
              ZIPCODE
            </label>
            <input
              type="text"
              name="zip"
              autoComplete="new-password"
              value={formData.sourceAddress?.zip}
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleSourceAddressChange}
            />
          </div>
          <p className="font-black text-base w-full text-primary">DESTINATION ADDRESS</p>
          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="address" className="block text-parameter w-1/3 text-sm">
              ADDRESS
            </label>
            <input
              type="text"
              value={formData.destinationAddress?.location}
              name="location"
              autoComplete="new-password"
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleDestinationAddressChange}
            />
          </div>
          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="city" className="block text-parameter w-1/3 text-sm">
              CITY
            </label>
            <input
              type="text"
              autoComplete="new-password"
              value={formData.destinationAddress?.city}
              name="city"
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleDestinationAddressChange}
            />
          </div>
          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="state" className="block text-parameter w-1/3 text-sm">
              STATE
            </label>
            <input
              type="text"
              name="state"
              autoComplete="new-password"
              value={formData.destinationAddress?.state}
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleDestinationAddressChange}
            />
          </div>
          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="country" className="block text-parameter w-1/3 text-sm">
              COUNTRY
            </label>
            <input
              type="text"
              name="country"
              autoComplete="new-password"
              value={formData.destinationAddress?.country}
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleDestinationAddressChange}
            />
          </div>
          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="zip" className="block text-parameter w-1/3 text-sm">
              ZIPCODE
            </label>
            <input
              type="text"
              name="zip"
              autoComplete="new-password"
              value={formData.destinationAddress?.zip}
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleDestinationAddressChange}
            />
          </div>
          {action === 'create' ? '' : <div className="flex w-1/2 items-center  my-3.5" />}
          {action === 'create' ? (
            ''
          ) : (
            <div className="flex w-1/2 items-center my-3.5">
              <label htmlFor="role" className="block text-parameter w-1/3 text-sm">
                STATUS
              </label>

              <div className="rounded-lg bg-white px-2 py-3 focus:outline-none text-sm  text-parameter border w-1/2 h-10">
                <select
                  name="status"
                  value={formData.status}
                  className="border-none w-full focus:outline-none text-sm  text-parameter border "
                  onChange={handleInputChange}
                >
                  <option value="Active" className="fy-4">
                    Active
                  </option>
                  <option value="InActive" className="fy-4">
                    InActive
                  </option>
                </select>
              </div>
            </div>
          )}

          <div className="flex w-1/2 items-center  my-3.5 relative">
            <label className="block text-parameter w-1/3 text-sm" />
            {state2.isLoading || isLoading ? (
              <img src="assets/img/loader.svg" className="absolute w-16 right-36 mx-auto" alt="" />
            ) : (
              <input
                type="submit"
                className="rounded-lg focus:outline-none w-1/2 h-10 text-textBlue1 cursor-pointer "
                style={{ background: '#16406D33', border: '1px solid #16406D' }}
              />
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateOrganization;
